import { Map } from 'immutable';

/**
 * Custom messages for Trainhugger
 */

module.exports = new Map({
    'app.owner': 'Trainhugger',
    'app.owner.short': 'Trainhugger',
    'preference-centre.privacy-notice':
        'We\'d like to keep you updated about your trees, <{app.owner.short}> projects, your journeys and other relevant information. You can unsubscribe at any time.',
    'alertmessage.registration.failed.emailInUse':
        'Registration failed - this account already exists. Please log in or enter a different email address',
    'alertmessage.paymentRegistration.failed.emailInUse':
        'An account with the same email address already exists. Please log in or enter a different email address',
    'account.orders.refund.warning.manualRefund': 'For refund options, please visit ',
    'account.orders.refund.refundForm': '{url}',
    'header.welcome': 'Welcome,',
    'account.register.opt.description':
        'We’d like to keep you updated about your trees, Trainhugger eco projects, ticket expiries and renewals, and other relevant information. You can unsubscribe at any time.',
    'preference-centre.promotions': 'Yes, I’d like to receive updates about my trees, my journeys and other relevant information.',
    'form.termsAndConditions.capitalised': 'OnTrack Retail\'s Terms & Conditions',
    'form.termsYouAgreeTo':
        `By clicking pay you agree to {termsAndConditions} and that the {nationalRailTerms}
         govern your purchase and the terms of your journey.`,
    'button.text.paymentDetailsOthers': 'Back',
    'account.deleteUserModal.information': 'Not having an account with us means it will take longer to complete some actions on our app and website, such as buying a ticket, claiming compensation and getting a refund, and you will no longer receive offers or important updates.',

    'account.nav.disruptionAlerts': 'Timetable alerts',
});



// WEBPACK FOOTER //
// ./src/messages/trainhugger.js